import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { contractDraftsQueryKey } from '@services/contracts/drafts'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

type SendDraftBody = {
  offer_id: string
  start_date: string
  end_date: string
  sna_fee?: boolean
}

// Backend vracia, komu návrh odišiel a komu nie — jeden neúspešný adresát
// nezhodí ostatných, tak to treba vedieť zobraziť.
type SendDraftResult = {
  sent: string[]
  failed: string[]
}

export function useSendOfferContractDraft() {
  const toast = useToast()
  const { t } = useTranslation('offers')
  const onError = useOnError()
  const queryClient = useQueryClient()

  async function sendDraft(body: SendDraftBody) {
    const res = await apiClient.post<SendDraftResult>(
      `${SNA_PREFIX}contracts/offers/send-draft`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: sendDraft,
    onSuccess: (data) => {
      if (data.failed?.length) {
        toast.error({
          message: t('admin.actions.draft_partially_sent', {
            emails: data.failed.join(', ')
          })
        })
        return
      }
      toast.success({
        message: t('admin.actions.draft_sent', { total: data.sent.length })
      })
    },
    onError,
    // A failed attempt is recorded too, so refresh either way.
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: contractDraftsQueryKey })
  })
}
